import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PhFiltersAction, PhFiltersService } from './../../ph-filters.service';
import { PhFiltersDataEmitter } from '@shared/components/ph-filters/ph-filters.service';
import { FiltersParams } from '@shared/models/filters/filters-params.model';
import { BaseComponent } from '@shared/components/base.component';
import { PhInputComponent } from '@shared/components/ph-input/ph-input.component';

@Component({
  selector: 'app-filter-search',
  templateUrl: './filter-search.component.html',
  styleUrls: ['./filter-search.component.scss'],
})
export class FilterSearchComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() correctForm: UntypedFormGroup = null;
  @Input() searchAutoFocus: boolean = false;
  @Input() placeholder: string;
  @ViewChild('searchInput', { static: true }) searchInput: PhInputComponent;
  searchingTimeout: any = null;
  params: FiltersParams = this.filtersService.params;

  constructor(public filtersService: PhFiltersService) {
    super();
  }

  ngOnInit() {
    setTimeout(this.checkUrlParams.bind(this), 400);
    const subStorageSub = this.storage.storageSub.subscribe((el) => {
      if (el === 'added') {
        this.searchInput.focusOnInput();
      }
    });
    this.someSubscriptions.add(subStorageSub);
  }

  ngAfterViewInit() {
    this.storage.get('autofocus')
      ? (this.searchInput.autoFocus = true)
      : (this.searchInput.autoFocus = false);
  }

  get c() {
    return this.correctForm.get('search');
  }

  onSearch(event) {
    clearTimeout(this.searchingTimeout);
    this.searchingTimeout = setTimeout(() => {
      this.updateParams();
    }, 400);
  }

  updateParams() {
    this.filtersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: {
          search: this.c.value,
        },
      })
    );
  }

  checkUrlParams() {
    const params: FiltersParams = this.filtersService.params;
    if (params.search) {
      this.c.patchValue(params.search, { emitEvent: false });
    }
  }
}
